
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { AthleteContext } from '../context/athelete';
import OverlayTrigger from 'react-bootstrap/esm/OverlayTrigger';
import Modal from 'react-bootstrap/Modal';
import { useContext, useEffect, useMemo, useState } from 'react';

//material-ui
import RefreshIcon from '@material-ui/icons/Refresh';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterIcon from '@material-ui/icons/FilterList';
import PageViewIcon from '@material-ui/icons/Pageview';
import { Loading, PaginatedTable } from '../common/variables';
import Table from 'react-bootstrap/esm/Table';
import { Badge, IconButton } from '@material-ui/core';
import { AppContext } from '../context/app';
import Tooltip from 'react-bootstrap/esm/Tooltip';


export function Athletes(){
  const { showAppToast , hideAppToast,  } = useContext(AppContext);
    const { athleteState : {athletes} , getAthletes , removeAthlete} = useContext(AthleteContext);
    const [loading , setLoading] = useState(true);
    const [perPage , setPerPage] = useState(10);
    const [selectingFilters , setSelectingFilters] = useState(false);
    const [filter ,setFilter] = useState({});
    const { setCurrentView, setAtheleteInView} = useContext(AppContext);
    const [validatingDelete , setValidatingDelete] = useState(false);
    const [athleteToDelete , setAthleteToDelete] = useState(null);
    useEffect(()=>{
      try{
        getAthletes();
      }
      finally{
        setTimeout(()=>setLoading(false) ,1000);
      }
    },[]);
    async function handleAthleteRefresh(){
      try{
        setLoading(true); 
        getAthletes();
      }
      finally{
        setTimeout(()=>setLoading(false) ,1000);
      }
    }
    const filtered_athletes = useMemo(()=>{
      if(Object.keys(filter).length === 0){
        return athletes;
      }
      return athletes.filter((athlete)=>{
        let expr = true;
        for(const key in filter){
          if(key==="school"){
            if(!athlete.school){
              return;
            }
            expr = expr && athlete.school.name.toLowerCase().startsWith(filter[key].toLowerCase());
            continue;
          }
          if(key==="club"){
            if(!athlete.club){
              return;
            }
            expr = expr && athlete.club.name.toLowerCase().startsWith(filter[key].toLowerCase());
            continue;
          }
          if((key=== "aab_verified")){
            expr = expr && (athlete[key] && (athlete[key] === JSON.parse(filter[key])) || (!athlete[key] && !JSON.parse(filter[key])));
            continue;
          }
          expr = expr && athlete[key].toLowerCase().startsWith(filter[key].toLowerCase());
        }
        return expr;
      });
    },[filter,athletes]);
    const FilterSelectRow = ()=>{
      return(
        <Table>
          <tbody style={{marginBottom : 4}}>
          <tr>
            <td style={{width : 20}}></td>
            <td style={{width : 125}}><Form.Control placeholder="Filter ID" type="text" value={filter.id} onChange={(e)=>setFilter({ ...filter ,"id" : e.target.value})}/></td>
            <td style={{width : 125}}><Form.Control placeholder="Filter first name" type="text" value={filter.first_name} onChange={(e)=>setFilter({ ...filter ,"first_name" : e.target.value})}/></td>
            <td style={{width : 125}}><Form.Control placeholder="Filter last name" type="text" value={filter.last_name} onChange={(e)=>setFilter({ ...filter ,"last_name" : e.target.value})}/></td>
            <td style={{width : 200}}><Form.Control placeholder="Filter email" type="text" value={filter.email} onChange={(e)=>setFilter({ ...filter ,"email" : e.target.value})}/></td>
            <td style={{width : 200}}><Form.Control placeholder="Filter school" type="text" value={filter.school} onChange={(e)=>setFilter({ ...filter ,"school" : e.target.value})}/></td>
            <td style={{width : 200}}><Form.Control placeholder="Filter club" type="text" value={filter.club} onChange={(e)=>setFilter({ ...filter ,"club" : e.target.value})}/></td>
            <td style={{width : 125}}>
                <Form.Control  as="select" onChange={(e)=>setFilter({ ...filter ,"aab_verified" : e.target.value})} value={filter.aab_verified}>
                  <option value={null}>-- Fee Status --</option>
                  <option value={false}>Due</option>
                  <option value={true}>Paid In Full</option>
                </Form.Control>
            </td>
          </tr>
        </tbody>
        </Table>
      )
    }

    async function handleAthleteDelete(){
      try{
        await removeAthlete({id : athleteToDelete.id});
        getAthletes();
        showAppToast(`${athleteToDelete.first_name} ${athleteToDelete.lastst_name} deleted`,"success");
      }
      catch(err){
        showAppToast(`Error when deleting ${athleteToDelete.first_name} ${athleteToDelete.last_name}`,"error");
        console.log(err);
      }
      finally{
        setTimeout(()=>hideAppToast(),1000);
        setValidatingDelete(false);
      }
    }
    return(
      <div className="mr-2 p-2  d-flex flex-column">
        <div className="d-flex mb-1 justify-content-between">
            <h4>Athletes</h4>
            <div className="d-flex align-items-center">
                <>
                {Object.keys(filter).length !== 0 &&<IconButton disabled={Object.keys(filter).length === 0} style={{marginRight : 2 ,outline:"none" , padding : 1}} className="text-danger" onClick={()=>setFilter({})}><ClearIcon/></IconButton>}
                    {
                      <>
                          <IconButton style={{marginRight : 1 ,outline:"none" , position : "relative" , padding : 1}} onClick={()=>setSelectingFilters(!selectingFilters)}>
                          <FilterIcon/>
                          { Object.keys(filter).length !== 0 && <Badge className="bg-info" style={{width :10 , height : 10 , borderRadius : "50%" , position : "absolute" , top: 0 , right : 0 , }}/>}
                        </IconButton>
                        <p style={{fontSize : "70%" , marginBottom : 0 , marginLeft : 1 ,marginRight : 8 }}>Filter</p>
                      </>
                    }
                </>
                <Form.Control  style={{width : 100 , marginRight : 4}} as="select" value={perPage} onChange={(e)=>setPerPage(e.target.value)}>
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                </Form.Control>
                <Button size="sm" variant="outline-success"  onClick={handleAthleteRefresh} ><RefreshIcon/></Button>
            </div>
        </div>
        {
          loading ? <Loading/> :
          <>
            { selectingFilters && FilterSelectRow() }
          <PaginatedTable striped bordered
            items={filtered_athletes}
            renderEmpty={<tr><td colSpan={8} style={{padding : 8 , textAlign : "center"}}>No Registered Athletes</td></tr>}
            thead={<tr><th>ID Number</th><th>First Name</th><th>Last Name</th><th>Date of Birth</th><th>Email</th><th>Schhol</th><th>Club</th><th>AAB Verification</th><th/></tr>}
            renderRowAs={({item :athlete})=>{
              return (
                <tr key={athlete.id}>
                  <td>{athlete.id}</td>
                  <td>{athlete.first_name}</td>
                  <td>{athlete.last_name}</td>
                  <td>{athlete.dob}</td>
                  <td>{athlete.email}</td>
                  <td>
                      {
                          athlete.school ? 
                          <div style={{display : "flex" , alignItems : "center"}}><p className="mb-0">{athlete.school.name}</p><VerifiedUserIcon style={{fontSize :"1.1rem"}} className={`ml-1 text-${athlete.club_verified ? "info" : "danger"}`}/></div>: 
                          <div style={{display : "flex" , alignItems : "center"}}><em className="mb-0">Not attached</em></div>
                        }
                  </td>
                  <td>
                      {
                          athlete.club ? 
                          <div style={{display : "flex" , alignItems : "center"}}><p className="mb-0">{athlete.club.name}</p><VerifiedUserIcon style={{fontSize :"1.1rem"}} className={`ml-1 text-${athlete.club_verified ? "info" : "danger"}`}/></div>: 
                          <div style={{display : "flex" , alignItems : "center"}}><em className="mb-0">Not attached</em></div>
                        }
                  </td>
                  <td style={{textAlign : "center"}}>
                    <IconButton  className={`text-${athlete.aab_verified ? "default" : "warning"} p-1ml-1`}><VerifiedUserIcon style={{fontSize :"1rem"}}/></IconButton>
                  </td>
                  <td style={{textAlign : "center"}}>
                    <IconButton  className="p-1 text-info" onClick={()=>{setCurrentView(`#athleteDetails?a=${athlete.id}`) ; setAtheleteInView(athlete)}}>
                      <OverlayTrigger placement="top" overlay={<Tooltip>{true&&"View Details"}</Tooltip>}>
                        <PageViewIcon />
                      </OverlayTrigger>
                     </IconButton> 
                      <IconButton className="p-1 text-danger" onClick={()=>{setAthleteToDelete(athlete);setValidatingDelete(true)}}>
                          <OverlayTrigger placement="top" overlay={<Tooltip>{true&&"Delete"}</Tooltip>}>
                            <DeleteIcon  />
                        </OverlayTrigger>
                      </IconButton>
                  </td>
                </tr>
              )
            }}
            perPage={perPage}
          />
          </>
         }
          {validatingDelete && athleteToDelete &&
            <Modal show>
              <Modal.Header closeButton onHide={()=>setValidatingDelete(false)}>
                  <Modal.Title>{`Delete Athlete`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>You have chosen to delete the <strong>{`${athleteToDelete.first_name} ${athleteToDelete.last_name} `}</strong>. This action cannot be undone.</p>
                  <p>Do you wish to continue?</p>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={()=>setValidatingDelete(false)}>
                    Close
                  </Button>
                  <Button variant="danger" onClick={handleAthleteDelete}>Delete</Button>
                </Modal.Footer>
            </Modal>
          }
    </div>)
  }